import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicExtended from "ckeditor5-build-classic-extended";

import "src/components/core/TextEditor/editor.css";

const defaultConfig = {
  toolbar: [
    "undo",
    "redo",
    "heading",
    "|",
    "bold",
    "bulletedList",
    "numberedList",
  ],
  heading: {
    options: [
      {
        model: "heading3",
        view: "h3",
        title: "Heading",
        class: "ck-heading_heading3",
      },
      {
        model: "paragraph",
        title: "Body",
        class: "ck-heading_paragraph",
      },
    ],
  },
};

function TextEditor({
  onChange,
  editorLoaded,
  name,
  value,
  customConfig = { ...defaultConfig },
}) {
  return (
    <div>
      {editorLoaded ? (
        <CKEditor
          type=""
          name={name}
          editor={ClassicExtended}
          config={customConfig}
          data={value}
          onChange={(event, editor) => {
            const data = editor.getData();
            // console.log({ event, editor, data })
            onChange(data);
          }}
        />
      ) : (
        <div>Editor loading</div>
      )}
    </div>
  );
}

export default TextEditor;
